import { TT } from '../types';
export default {
  type: TT,
  service: 'THUNDERCORE',
  url: 'https://mainnet-rpc.thundercore.com',
  port: 443,
  auth: false,
  username: '',
  password: ''
};
